export default __webpack_public_path__ + "static/media/FS-ABOUT-EQUIPO-IMAGEN.20f51bdb.png";